import firebase from 'firebase/compat'
import { useDocumentData } from 'hooks/firebase'
import { IUser } from '.'

export const useUser = (uid: string) =>
  useDocumentData<IUser>(firebase.firestore().collection('users').doc(uid))
